import React from 'react';
import { Lock, Shield, Download, ShieldCheck, Headphones } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function OfferSection() {
  const checkoutLink = 'https://pay.hotmart.com/Q104948761S?checkoutMode=10';
  return <section id="oferta" className="py-16 px-4 bg-gray-50" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100" data-id="element-89">
          <div className="bg-blue-900 p-6 text-center" data-id="element-90">
            <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-91">
              Riepilogo dell'Ordine
            </h2>
          </div>

          <div className="p-6 md:p-10 flex flex-col md:flex-row gap-8" data-id="element-92">
            {/* Left Column - Image & List */}
            <div className="w-full md:w-1/2" data-id="element-93">
              <div className="relative h-48 mb-8 flex justify-center items-center" data-id="element-94">
                <img src="https://cdn.magicpatterns.com/uploads/gsVEyfjnzcuvgW4HC3rG6m/Tomo_4.png" alt="Book" className="absolute w-1/4 -translate-x-full translate-y-4 -rotate-12 shadow-md rounded" data-id="element-95" />
                <img src="https://cdn.magicpatterns.com/uploads/f4Zd95gcYtK15ny8x2VRuN/Tomo_2.png" alt="Book" className="absolute w-1/4 -translate-x-1/2 translate-y-2 -rotate-6 shadow-lg rounded" data-id="element-96" />
                <img src="https://cdn.magicpatterns.com/uploads/1GeMRcLpmUHx4qsugtEApX/Tomo_5.png" alt="Book" className="absolute w-1/4 translate-x-1/2 translate-y-2 rotate-6 shadow-lg rounded" data-id="element-97" />
                <img src="https://cdn.magicpatterns.com/uploads/crX2ptMyf6Ln3wgTVHvb6J/Tomo_3.png" alt="Book" className="absolute w-1/4 translate-x-full translate-y-4 rotate-12 shadow-md rounded" data-id="element-98" />
                <img src="https://cdn.magicpatterns.com/uploads/tjgkzNkd3KeZC2JTS9FMDA/Tomo_1.png" alt="Book" className="absolute w-1/3 scale-110 shadow-xl rounded z-10" data-id="element-99" />
              </div>

              <div className="space-y-3 text-sm md:text-base" data-id="element-100">
                <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-101">
                  <span className="text-gray-700" data-id="element-102">
                    Manuale di Yoga per Bambini
                  </span>
                  <span className="font-semibold" data-id="element-103">19,99 €</span>
                </div>
                <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-104">
                  <span className="text-gray-700" data-id="element-105">
                    Giochi e Attività di Movimento
                  </span>
                  <span className="font-semibold" data-id="element-106">14,99 €</span>
                </div>
                <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-107">
                  <span className="text-gray-700" data-id="element-108">Diario di Mindfulness</span>
                  <span className="font-semibold" data-id="element-109">14,99 €</span>
                </div>
                <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-110">
                  <span className="text-gray-700" data-id="element-111">
                    Carte e Poster Posizioni
                  </span>
                  <span className="font-semibold" data-id="element-112">12,99 €</span>
                </div>
                <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-113">
                  <span className="text-gray-700" data-id="element-114">
                    Yoga per Famiglia e Scuola
                  </span>
                  <span className="font-semibold" data-id="element-115">14,99 €</span>
                </div>
                <div className="flex justify-between items-center border-b border-gray-100 pb-2 text-green-600" data-id="element-116">
                  <span data-id="element-117">BONUS: 30 Storie di Yoga</span>
                  <div className="text-right" data-id="element-118">
                    <span className="line-through text-gray-400 text-xs mr-2" data-id="element-119">
                      19,99 €
                    </span>
                    <span className="font-bold" data-id="element-120">GRATIS</span>
                  </div>
                </div>
                <div className="flex justify-between items-center border-b border-gray-100 pb-2 text-green-600" data-id="element-121">
                  <span data-id="element-122">BONUS: 50 Carte Respirazione</span>
                  <div className="text-right" data-id="element-123">
                    <span className="line-through text-gray-400 text-xs mr-2" data-id="element-124">
                      14,99 €
                    </span>
                    <span className="font-bold" data-id="element-125">GRATIS</span>
                  </div>
                </div>
                <div className="flex justify-between items-center border-b border-gray-100 pb-2 text-green-600" data-id="element-126">
                  <span data-id="element-127">BONUS: 21 Routine di Yoga</span>
                  <div className="text-right" data-id="element-128">
                    <span className="line-through text-gray-400 text-xs mr-2" data-id="element-129">
                      17,99 €
                    </span>
                    <span className="font-bold" data-id="element-130">GRATIS</span>
                  </div>
                </div>
                <div className="flex justify-between items-center pb-2 text-green-600" data-id="element-131">
                  <span data-id="element-132">BONUS: Attività Creative</span>
                  <div className="text-right" data-id="element-133">
                    <span className="line-through text-gray-400 text-xs mr-2" data-id="element-134">
                      12,99 €
                    </span>
                    <span className="font-bold" data-id="element-135">GRATIS</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Price & CTA */}
            <div className="w-full md:w-1/2 flex flex-col justify-center items-center bg-gray-50 p-6 rounded-2xl border border-gray-200" data-id="element-136">
              <div className="text-center mb-6" data-id="element-137">
                <p className="text-gray-500 mb-1" data-id="element-138">
                  Valore totale: <span className="line-through" data-id="element-139">144,96 €</span>
                </p>
                <p className="text-gray-600 text-lg mb-2" data-id="element-140">
                  Prezzo originale:{' '}
                  <span className="line-through" data-id="element-141">49,99 €</span>
                </p>
                <div className="text-green-600 font-black text-6xl md:text-7xl mb-2 drop-shadow-sm" data-id="element-142">
                  15,99 <span className="text-2xl md:text-3xl" data-id="element-143">€</span>
                </div>
                <p className="text-sm font-semibold text-red-600 uppercase tracking-wide" data-id="element-144">
                  Pagamento unico. Nessun abbonamento.
                </p>
              </div>

              <div className="mb-6 w-full flex justify-center" data-id="element-145">
                <CountdownTimer variant="red" size="sm" data-id="element-146" />
              </div>

              <button onClick={() => window.open(checkoutLink, '_blank')} className="w-full bg-green-600 hover:bg-green-700 text-white font-black text-xl md:text-2xl py-6 px-8 rounded-full shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 animate-pulse flex flex-col items-center justify-center leading-tight" data-id="element-147">
                <span data-id="element-148">ACQUISTA ORA</span>
                <span className="text-sm font-medium opacity-90 mt-1" data-id="element-149">
                  a soli 15,99 €
                </span>
              </button>

              <div className="mt-6 flex flex-wrap justify-center gap-3 text-gray-400" data-id="element-150">
                <Lock className="w-5 h-5" data-id="element-151" />
                <Shield className="w-5 h-5" data-id="element-152" />
                <Download className="w-5 h-5" data-id="element-153" />
                <ShieldCheck className="w-5 h-5" data-id="element-154" />
                <Headphones className="w-5 h-5" data-id="element-155" />
              </div>
              <p className="text-xs text-gray-400 mt-2 text-center" data-id="element-156">
                Pagamento 100% sicuro e criptato
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}